import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const CURRENCY_KEYS = {
  "Platinum Pieces": "platinum",
  "Gold Pieces": "gold",
  "Silver Pieces": "silver",
  "Copper Pieces": "copper",
};

const MoneyInput = ({ character, onChange }) => {
  const { t } = useTranslation();
  const [money, setMoney] = useState(character.inventory.money);

  useEffect(() => {
    setMoney(character.inventory.money);
  }, [character.inventory.money]);

  const handleChange = (currency, newAmount) => {
    setMoney((previousMoney) => {
      const nextMoney = previousMoney.map((entry) => entry.currency === currency
        ? { ...entry, amount: Math.max(0, parseInt(newAmount, 10) || 0) }
        : entry);
      onChange(nextMoney);
      return nextMoney;
    });
  };

  return (
    <section className="money-section" aria-label={t("inventory.money")}>
      <h2 className="money-header">{t("inventory.money")}</h2>
      <div className="money-input-container">
        {money.map((currencyObj) => {
          const currencyKey = CURRENCY_KEYS[currencyObj.currency];
          const translationKey = `inventory.currencies.${currencyKey}`;

          return (
            <label key={currencyObj.currency} className="money-input-group">
              <span title={t(`${translationKey}.name`, { defaultValue: currencyObj.currency })}>
                {t(`${translationKey}.short`, { defaultValue: currencyObj.currency })}
              </span>
              <input
                type="number"
                min="0"
                name={currencyObj.currency}
                value={currencyObj.amount}
                onChange={(event) => handleChange(currencyObj.currency, event.target.value)}
              />
            </label>
          );
        })}
      </div>
    </section>
  );
};

export default MoneyInput;